import classNames from 'classnames';

import * as styles from './Card.module.css';

type Props = {
    backgroundcolor?: string;
    hasboxshadow?: boolean;
    hasmedallion: boolean;
    medallionurl: string;
    textcolor?: string;
};

const Card = ({
    backgroundcolor = 'bg-white',
    children,
    hasboxshadow = true,
    hasmedallion = false,
    medallionurl = '',
    textcolor = 'text-black',
}: React.PropsWithChildren<Props>) => {
    return (
        <div
            className={classNames(
                'card-container card-container_medallion',
                backgroundcolor,
                'md:h-full relative rounded-lg pb-6 px-4 md:pb-10 md:px-6',
                styles.cardWithMedallion,
                textcolor
            )}
            style={
                hasboxshadow
                    ? { boxShadow: '0 1px 3px hsl(0deg 0% 40% / 20%)' }
                    : { boxShadow: 'none' }
            }
        >
            {hasmedallion && (
                <span className="block absolute -top-12 left-0 right-0">
                    <img src={medallionurl} alt="" className="mx-auto" width="96" height="96" />
                </span>
            )}
            <div className={medallionurl ? 'pt-16' : 'pt-6'}>{children}</div>
        </div>
    );
};

Card.displayName = 'CardWithMedalion';

export default Card;
